var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ArrowBack } from '@mui/icons-material';
import { Box, Chip, Typography, useMediaQuery } from '@mui/material';
import dayjs from 'dayjs';
import { DownloadSvgIcon, PrintSvgIcon, ShareLineSvgIcon } from '../../../assets/customIcons';
import { ReactComponent as CloseIcon } from '../../../assets/images/closeIcon.svg';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { labourElements, partElements } from '../component/labourPartListData';
import { LabourInvoiceDetails } from '../pages/labour.invoiceDetails';
import { PartInvoiceDetails } from '../pages/part.invoiceDetails';
import { getViewInvoiceDetails } from '../services/apiCall';
import { JCIPostingTypes, JobCardInvoicesKeys } from '../services/entity';
var InvoiceDetails = function (_ref) {
    var _crud$JobCardInvoices, _crud$JobCardInvoices2, _crud$JobCardInvoices3, _ref2, _customerInfo$data$Pe, _customerInfo$data, _customerInfo$data2, _customerInfo$data3, _customerInfo$data4, _customerInfo$data5, _customerInfo$data6, _crud$JobCardInvoices4, _crud$JobCardInvoices5, _crud$JobCardInvoices6, _crud$JobCardInvoices7, _crud$JobCardInvoices8, _ref3, _customerInfo$data$Pe2, _customerInfo$data7, _customerInfo$data8, _customerInfo$data9, _customerInfo$data10, _crud$JobCardInvoices9, _crud$JobCardInvoices10, _crud$JobCardInvoices11, _crud$JobCardInvoices12, _crud$JobCardInvoices13, _crud$JobCardInvoices14, _crud$JobCardInvoices15;
    var onClose = _ref.onClose, data = _ref.data;
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var _a = useAppSelector(function (state) { return state.crud; }), insallbase = _a.insallbase, customerInfo = _a.customerInfo, viewInvoiceDetails = _a.viewInvoiceDetails;
    var crud = useAppSelector(function (state) { return state.crud; });
    var multiInvoiceList = ((_crud$JobCardInvoices = crud[JobCardInvoicesKeys.ViewInvoiceDetails]) === null || _crud$JobCardInvoices === void 0 || (_crud$JobCardInvoices = _crud$JobCardInvoices.data) === null || _crud$JobCardInvoices === void 0 ? void 0 : _crud$JobCardInvoices.RelatedInvoices) || [];
    var dispatch = useAppDispatch();
    var invoiceDetails = [isMobile ? {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            mt: 2,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: '',
                    columnSize: 12,
                    flexDirection: "row",
                    pl: 2,
                    item: false,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: "",
                            columnSize: 0,
                            onClick: function (e) {
                                onClose();
                            },
                            children: /*#__PURE__*/ React.createElement(ArrowBack, {
                                fontSize: "small"
                            })
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            flexDirection: 'column',
                            columnSize: true,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    value: "Invoice details - ".concat((_crud$JobCardInvoices2 = crud[JobCardInvoicesKeys === null || JobCardInvoicesKeys === void 0 ? void 0 : JobCardInvoicesKeys.ViewInvoiceDetails]) === null || _crud$JobCardInvoices2 === void 0 || (_crud$JobCardInvoices2 = _crud$JobCardInvoices2.data) === null || _crud$JobCardInvoices2 === void 0 ? void 0 : _crud$JobCardInvoices2.JobCardNo),
                                    fontWeight: 'strong',
                                    fontSize: 'xxl',
                                    columnSize: true
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'ServiceTypeName',
                                    value: null,
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: true
                                }]
                        }, {
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(CloseIcon, {
                                color: "text.secondary",
                                height: '12px',
                                width: '12px'
                            }),
                            columnSize: 0,
                            onClick: function () {
                                onClose();
                            }
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: null,
                    columnSize: 12,
                    item: false,
                    justifyContent: "end",
                    columns: 0,
                    pt: '16px',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: 'View JC lifecycle',
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'primary'
                        }]
                }]
        } : {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            mt: 2,
            // minWidth: '100%',
            bgcolor: '#ffffff',
            flexDirection: 'row',
            justifyContent: 'space-between',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: '',
                    columnSize: true,
                    display: "flex",
                    pl: 2,
                    item: false,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: "",
                            columnSize: 0,
                            onClick: function () {
                                onClose();
                            },
                            children: /*#__PURE__*/ React.createElement(ArrowBack, {
                                fontSize: "small"
                            })
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            flexDirection: 'column',
                            columnSize: 10,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    value: "Invoice details - ".concat((_crud$JobCardInvoices3 = crud[JobCardInvoicesKeys === null || JobCardInvoicesKeys === void 0 ? void 0 : JobCardInvoicesKeys.ViewInvoiceDetails]) === null || _crud$JobCardInvoices3 === void 0 || (_crud$JobCardInvoices3 = _crud$JobCardInvoices3.data) === null || _crud$JobCardInvoices3 === void 0 ? void 0 : _crud$JobCardInvoices3.JobCardNo),
                                    fontWeight: 'strong',
                                    fontSize: 'xxl',
                                    columnSize: true
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'ServiceTypeName',
                                    value: null,
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 0
                                }]
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: null,
                    columnSize: true,
                    item: false,
                    justifyContent: "end",
                    alignItems: 'center',
                    columns: 0,
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: 'View JC lifecycle',
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'primary'
                        }, {
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(CloseIcon, {
                                color: "text.secondary",
                                height: '12px',
                                width: '12px'
                            }),
                            columnSize: 0,
                            onClick: function () {
                                onClose(false);
                            },
                            sx: {
                            // padding: '12px'
                            }
                        }]
                }]
        }, {
            type: FormItemTypes.Divider,
            name: '',
            columnSize: 12
        }, isMobile ? {
            type: FormItemTypes.ContainerItem,
            name: 'invoiceDetails',
            columnSize: 12,
            spacing: 0,
            elements: [{
                    type: FormItemTypes.Accordian,
                    name: 'jobcardInvoiceDetails',
                    columnSize: 12,
                    value: false,
                    sx: {
                        borderRight: 'none',
                        borderRadius: '0px',
                        borderLeft: 'none'
                    },
                    summaryProps: {
                        sx: {
                            padding: 0
                        }
                    },
                    summary: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 0,
                            children: 'job card invoice details',
                            fontSize: 'lg',
                            fontWeight: 'strong'
                        }],
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: 'header',
                            columnSize: 12,
                            sx: {
                                margin: '12px 0px 12px 12px'
                            },
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: 'job card invoice details',
                                    label: 'job card invoice details',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    columnSize: 12,
                                    spacing: 0,
                                    padding: '8px 0px 8px 12px ',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: 'InvoiceNumber',
                                            label: 'Job card invoice number:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'InvoiceDate',
                                            label: 'invoice date:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                if (formData !== null && formData !== void 0 && formData.InvoiceDate) {
                                                    var InvoiceDate = formData !== null && formData !== void 0 && formData.InvoiceDate ? dayjs.utc(formData === null || formData === void 0 ? void 0 : formData.InvoiceDate).format('DD MMM, YYYY') : '-';
                                                    return InvoiceDate;
                                                }
                                                else {
                                                    return '-';
                                                }
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'JobCardNo',
                                            label: 'Job card number:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                if (formData !== null && formData !== void 0 && formData.JobCardNo) {
                                                    var JobCardNo = formData !== null && formData !== void 0 && formData.JobCardNo ? formData === null || formData === void 0 ? void 0 : formData.JobCardNo : '-';
                                                    return JobCardNo;
                                                }
                                                else {
                                                    return '-';
                                                }
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'PostingTypeName',
                                            label: 'Posting type:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                if (formData !== null && formData !== void 0 && formData.PostingTypeName) {
                                                    var PostingTypeName = formData !== null && formData !== void 0 && formData.PostingTypeName ? formData === null || formData === void 0 ? void 0 : formData.PostingTypeName : '-';
                                                    return PostingTypeName;
                                                }
                                                else {
                                                    return '-';
                                                }
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'ServiceTypeName',
                                            label: 'Service type:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                if (formData !== null && formData !== void 0 && formData.ServiceTypeName) {
                                                    var ServiceTypeName = formData !== null && formData !== void 0 && formData.ServiceTypeName ? formData === null || formData === void 0 ? void 0 : formData.ServiceTypeName : '-';
                                                    return ServiceTypeName;
                                                }
                                                else {
                                                    return '-';
                                                }
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'ServiceAdvisorName',
                                            label: 'Service advisor',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                if (formData !== null && formData !== void 0 && formData.ServiceAdvisorName) {
                                                    var ServiceAdvisorName = formData !== null && formData !== void 0 && formData.ServiceAdvisorName ? formData === null || formData === void 0 ? void 0 : formData.ServiceAdvisorName : '-';
                                                    return ServiceAdvisorName;
                                                }
                                                else {
                                                    return '-';
                                                }
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'CampaignName',
                                            label: 'Campaign: ',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                if (formData !== null && formData !== void 0 && formData.CampaignName) {
                                                    var CampaignName = formData !== null && formData !== void 0 && formData.CampaignName ? formData === null || formData === void 0 ? void 0 : formData.CampaignName : '-';
                                                    return CampaignName;
                                                }
                                                else {
                                                    return '-';
                                                }
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'DelayReason',
                                            label: 'Delay reason:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                if (formData !== null && formData !== void 0 && formData.DelayReason) {
                                                    var DelayReason = formData !== null && formData !== void 0 && formData.DelayReason ? formData === null || formData === void 0 ? void 0 : formData.DelayReason : '-';
                                                    return DelayReason;
                                                }
                                                else {
                                                    return '-';
                                                }
                                            }
                                        }]
                                }]
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'InvoiceSummary ',
                    columnSize: 12,
                    value: false,
                    sx: {
                        borderLeft: 'none',
                        borderRight: 'none',
                        borderTop: 'none',
                        borderRadius: '0px'
                    },
                    summaryProps: {
                        sx: {
                            padding: 0
                        }
                    },
                    summary: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 0,
                            children: 'Invoice summary ',
                            fontSize: 'lg',
                            fontWeight: 'strong'
                        }],
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: 'header',
                            columnSize: 12,
                            sx: {
                                margin: '12px 0px 12px 12px'
                            },
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: 'Invoice summary',
                                    label: 'Invoice summary',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    columnSize: 12,
                                    spacing: 0,
                                    padding: '8px 0px 8px 12px ',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: 'GrandTotal',
                                            label: 'Basic amount: ',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                if (formData !== null && formData !== void 0 && formData.GrandTotal) {
                                                    var GrandTotal = formData !== null && formData !== void 0 && formData.GrandTotal ? formData === null || formData === void 0 ? void 0 : formData.GrandTotal : '-';
                                                    return GrandTotal;
                                                }
                                                else {
                                                    return '-';
                                                }
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'TotalDiscount',
                                            label: 'Discount: ',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                if (formData !== null && formData !== void 0 && formData.TotalDiscount) {
                                                    var TotalDiscount = formData !== null && formData !== void 0 && formData.TotalDiscount ? formData === null || formData === void 0 ? void 0 : formData.TotalDiscount : '-';
                                                    return TotalDiscount;
                                                }
                                                else {
                                                    return '-';
                                                }
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'OtherCharges',
                                            label: 'Charges: ',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                if (formData !== null && formData !== void 0 && formData.OtherCharges) {
                                                    var OtherCharges = formData !== null && formData !== void 0 && formData.OtherCharges ? formData === null || formData === void 0 ? void 0 : formData.OtherCharges : '-';
                                                    return OtherCharges;
                                                }
                                                else {
                                                    return '-';
                                                }
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'TaxableAmount',
                                            label: 'Taxable amount: ',
                                            value: '0',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                if (formData !== null && formData !== void 0 && formData.TaxableAmount) {
                                                    var TaxableAmount = formData !== null && formData !== void 0 && formData.TaxableAmount ? formData === null || formData === void 0 ? void 0 : formData.TaxableAmount : '-';
                                                    return TaxableAmount;
                                                }
                                                else {
                                                    return '-';
                                                }
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'CGSTAmount',
                                            label: 'CGST',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                if (formData !== null && formData !== void 0 && formData.CGSTAmount) {
                                                    var CGSTAmount = formData !== null && formData !== void 0 && formData.CGSTAmount ? formData === null || formData === void 0 ? void 0 : formData.CGSTAmount : '-';
                                                    return CGSTAmount;
                                                }
                                                else {
                                                    return '-';
                                                }
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'SGSTAmount',
                                            label: 'SGST',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                if (formData !== null && formData !== void 0 && formData.SGSTAmount) {
                                                    var SGSTAmount = formData !== null && formData !== void 0 && formData.SGSTAmount ? formData === null || formData === void 0 ? void 0 : formData.SGSTAmount : '-';
                                                    return SGSTAmount;
                                                }
                                                else {
                                                    return '-';
                                                }
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'IGStAmount',
                                            label: 'IGST: ',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                if (formData !== null && formData !== void 0 && formData.IGStAmount) {
                                                    var IGStAmount = formData !== null && formData !== void 0 && formData.IGStAmount ? formData === null || formData === void 0 ? void 0 : formData.IGStAmount : '-';
                                                    return IGStAmount;
                                                }
                                                else {
                                                    return '-';
                                                }
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'GrandTotal',
                                            label: 'Grand total:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                if (formData !== null && formData !== void 0 && formData.GrandTotal) {
                                                    var GrandTotal = formData !== null && formData !== void 0 && formData.GrandTotal ? formData === null || formData === void 0 ? void 0 : formData.GrandTotal : '-';
                                                    return GrandTotal;
                                                }
                                                else {
                                                    return '-';
                                                }
                                            }
                                        }]
                                }]
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'PaymentDetail',
                    columnSize: 12,
                    value: false,
                    sx: {
                        borderLeft: 'none',
                        borderRight: 'none',
                        borderTop: 'none',
                        borderRadius: '0px'
                    },
                    summaryProps: {
                        sx: {
                            padding: 0
                        }
                    },
                    summary: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 0,
                            children: 'Payment detail',
                            fontSize: 'lg',
                            fontWeight: 'strong'
                        }],
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: 'header',
                            columnSize: 12,
                            sx: {
                                margin: '12px 0px 12px 12px'
                            },
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: 'JC invoice return details',
                                    label: 'JC invoice return details',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    columnSize: 12,
                                    spacing: 0,
                                    padding: '8px 0px 8px 12px ',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: 'PaidAmount',
                                            label: 'Paid amount:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                var paid = formData === null || formData === void 0 ? void 0 : formData.PaidAmount;
                                                return paid !== null && paid !== undefined ? paid : '-';
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'OutStandingAmount',
                                            label: 'Outstanding amount:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                var OutStandingAmount = formData === null || formData === void 0 ? void 0 : formData.OutStandingAmount;
                                                return OutStandingAmount !== null && OutStandingAmount !== undefined ? OutStandingAmount : '-';
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'PaymentMode',
                                            label: 'Payment mode:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                if ((formData === null || formData === void 0 ? void 0 : formData.PaymentMode) === 1)
                                                    return 'Cash';
                                                if ((formData === null || formData === void 0 ? void 0 : formData.PaymentMode) === 2)
                                                    return 'Credit';
                                                return '-';
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'PaymentTypeName',
                                            label: 'Payment method:',
                                            value: '-',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'InvoiceDate',
                                            label: 'Payment date1234:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                if (formData !== null && formData !== void 0 && formData.InvoiceDate) {
                                                    var InvoiceDate = formData !== null && formData !== void 0 && formData.InvoiceDate ? dayjs.utc(formData === null || formData === void 0 ? void 0 : formData.InvoiceDate).format('DD MMM, YYYY') : '-';
                                                    return InvoiceDate;
                                                }
                                                else {
                                                    return '-';
                                                }
                                            }
                                        }]
                                }]
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'CustomerDetails',
                    columnSize: 12,
                    value: false,
                    sx: {
                        borderLeft: 'none',
                        borderRight: 'none',
                        borderTop: 'none',
                        borderRadius: '0px'
                    },
                    summaryProps: {
                        sx: {
                            padding: 0
                        }
                    },
                    summary: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 0,
                            children: 'Customer details',
                            fontSize: 'lg',
                            fontWeight: 'strong'
                        }],
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: 'header',
                            columnSize: 12,
                            sx: {
                                margin: '12px 0px 12px 12px'
                            },
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: 'Customer details',
                                    label: 'Customer details',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    columnSize: 12,
                                    spacing: 0,
                                    padding: '8px 0px 8px 12px ',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: 'Name',
                                            label: 'Name',
                                            value: (_ref2 = (_customerInfo$data$Pe = customerInfo === null || customerInfo === void 0 || (_customerInfo$data = customerInfo.data) === null || _customerInfo$data === void 0 || (_customerInfo$data = _customerInfo$data.Person) === null || _customerInfo$data === void 0 ? void 0 : _customerInfo$data.GivenName) !== null && _customerInfo$data$Pe !== void 0 ? _customerInfo$data$Pe : '-' + '' + (customerInfo === null || customerInfo === void 0 || (_customerInfo$data2 = customerInfo.data) === null || _customerInfo$data2 === void 0 || (_customerInfo$data2 = _customerInfo$data2.Person) === null || _customerInfo$data2 === void 0 ? void 0 : _customerInfo$data2.FamilyName)) !== null && _ref2 !== void 0 ? _ref2 : '-',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Mobile no:',
                                            label: 'Mobile no:',
                                            value: customerInfo === null || customerInfo === void 0 || (_customerInfo$data3 = customerInfo.data) === null || _customerInfo$data3 === void 0 ? void 0 : _customerInfo$data3.MobileNumber,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Address :',
                                            label: 'Address :',
                                            value: customerInfo === null || customerInfo === void 0 || (_customerInfo$data4 = customerInfo.data) === null || _customerInfo$data4 === void 0 || (_customerInfo$data4 = _customerInfo$data4.Address[0]) === null || _customerInfo$data4 === void 0 ? void 0 : _customerInfo$data4.Address1,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'unset',
                                                minWidth: '40%'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Mail',
                                            label: 'Mail',
                                            value: customerInfo !== null && customerInfo !== void 0 && (_customerInfo$data5 = customerInfo.data) !== null && _customerInfo$data5 !== void 0 && _customerInfo$data5.Email ? customerInfo === null || customerInfo === void 0 || (_customerInfo$data6 = customerInfo.data) === null || _customerInfo$data6 === void 0 ? void 0 : _customerInfo$data6.Email : '-',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }]
                                }]
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'VehicleDetails',
                    columnSize: 12,
                    value: false,
                    sx: {
                        borderLeft: 'none',
                        borderRight: 'none',
                        borderTop: 'none',
                        borderRadius: '0px'
                    },
                    summaryProps: {
                        sx: {
                            padding: 0
                        }
                    },
                    summary: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 0,
                            children: 'Vehicle details',
                            fontSize: 'lg',
                            fontWeight: 'strong'
                        }],
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: 'header',
                            columnSize: 12,
                            sx: {
                                margin: '12px 0px 12px 12px'
                            },
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: 'VehicleDetails',
                                    label: 'Vehicle details',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    columnSize: 12,
                                    spacing: 0,
                                    padding: '8px 0px 8px 12px ',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: 'RegistrationNo',
                                            label: 'Registration no.:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                var RegistrationNo = formData === null || formData === void 0 ? void 0 : formData.RegistrationNo;
                                                return RegistrationNo !== null && RegistrationNo !== undefined ? RegistrationNo : '-';
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'ProductName',
                                            label: 'Model',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                var ProductName = formData === null || formData === void 0 ? void 0 : formData.ProductName;
                                                return ProductName !== null && ProductName !== undefined ? ProductName : '-';
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'EngineNo',
                                            label: 'Engine no.:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                var EngineNo = formData === null || formData === void 0 ? void 0 : formData.EngineNo;
                                                return EngineNo !== null && EngineNo !== undefined ? EngineNo : '-';
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'VinNo',
                                            label: 'Chassis no.:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                var VinNo = formData === null || formData === void 0 ? void 0 : formData.VinNo;
                                                return VinNo !== null && VinNo !== undefined ? VinNo : '-';
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            label: 'Date of sale:',
                                            value: (_crud$JobCardInvoices4 = crud[JobCardInvoicesKeys === null || JobCardInvoicesKeys === void 0 ? void 0 : JobCardInvoicesKeys.ViewInvoiceDetails]) !== null && _crud$JobCardInvoices4 !== void 0 && (_crud$JobCardInvoices4 = _crud$JobCardInvoices4.data) !== null && _crud$JobCardInvoices4 !== void 0 && _crud$JobCardInvoices4.PaymentDuedate ? dayjs((_crud$JobCardInvoices5 = (_crud$JobCardInvoices6 = crud[JobCardInvoicesKeys === null || JobCardInvoicesKeys === void 0 ? void 0 : JobCardInvoicesKeys.ViewInvoiceDetails]) === null || _crud$JobCardInvoices6 === void 0 || (_crud$JobCardInvoices6 = _crud$JobCardInvoices6.data) === null || _crud$JobCardInvoices6 === void 0 ? void 0 : _crud$JobCardInvoices6.PaymentDuedate) !== null && _crud$JobCardInvoices5 !== void 0 ? _crud$JobCardInvoices5 : '-').format('DD MM YYYY') : '-',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }]
                                }]
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'InsuranceDetails',
                    columnSize: 12,
                    value: false,
                    sx: {
                        borderLeft: 'none',
                        borderRight: 'none',
                        borderTop: 'none',
                        borderRadius: '0px'
                    },
                    summaryProps: {
                        sx: {
                            padding: 0
                        }
                    },
                    summary: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 0,
                            children: 'Insurance details',
                            fontSize: 'lg',
                            fontWeight: 'strong'
                        }],
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: 'header',
                            columnSize: 12,
                            sx: {
                                margin: '12px 0px 12px 12px'
                            },
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: 'Insurance details',
                                    label: 'Insurance details',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    columnSize: 12,
                                    spacing: 0,
                                    padding: '8px 0px 8px 12px ',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: 'InsuredName',
                                            label: 'Insurer name:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'unset',
                                                minWidth: '40%'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                if (formData !== null && formData !== void 0 && formData.InsuredName) {
                                                    var InsuredName = formData !== null && formData !== void 0 && formData.InsuredName ? formData === null || formData === void 0 ? void 0 : formData.InsuredName : '-';
                                                    return InsuredName;
                                                }
                                                else {
                                                    return '-';
                                                }
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'PolicyExpiryDate',
                                            label: 'Policy date:',
                                            value: (_crud$JobCardInvoices7 = crud[JobCardInvoicesKeys === null || JobCardInvoicesKeys === void 0 ? void 0 : JobCardInvoicesKeys.ViewInvoiceDetails]) !== null && _crud$JobCardInvoices7 !== void 0 && (_crud$JobCardInvoices7 = _crud$JobCardInvoices7.data) !== null && _crud$JobCardInvoices7 !== void 0 && _crud$JobCardInvoices7.PolicyExpiryDate ? dayjs((_crud$JobCardInvoices8 = crud[JobCardInvoicesKeys === null || JobCardInvoicesKeys === void 0 ? void 0 : JobCardInvoicesKeys.ViewInvoiceDetails]) === null || _crud$JobCardInvoices8 === void 0 || (_crud$JobCardInvoices8 = _crud$JobCardInvoices8.data) === null || _crud$JobCardInvoices8 === void 0 ? void 0 : _crud$JobCardInvoices8.PolicyExpiryDate).format('DD MM YYYY') : '-',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'unset',
                                                minWidth: '40%'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'CoverageTypeName',
                                            label: 'Policy type:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'unset',
                                                minWidth: '40%'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                if (formData !== null && formData !== void 0 && formData.CoverageTypeName) {
                                                    var CoverageTypeName = formData !== null && formData !== void 0 && formData.CoverageTypeName ? formData === null || formData === void 0 ? void 0 : formData.CoverageTypeName : '-';
                                                    return CoverageTypeName;
                                                }
                                                else {
                                                    return '-';
                                                }
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'PolicyNumber',
                                            label: 'Policy no.:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'unset',
                                                minWidth: '40%'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                if (formData !== null && formData !== void 0 && formData.PolicyNumber) {
                                                    var PolicyNumber = formData !== null && formData !== void 0 && formData.PolicyNumber ? formData === null || formData === void 0 ? void 0 : formData.PolicyNumber : '-';
                                                    return PolicyNumber;
                                                }
                                                else {
                                                    return '-';
                                                }
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'InsuranceClaimNumber:',
                                            label: 'Insurance claim number:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'unset',
                                                minWidth: '40%'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                if (formData !== null && formData !== void 0 && formData.InsuranceClaimNumberd) {
                                                    var InsuranceClaimNumberd = formData !== null && formData !== void 0 && formData.InsuranceClaimNumberd ? formData === null || formData === void 0 ? void 0 : formData.InsuranceClaimNumberd : '-';
                                                    return InsuranceClaimNumberd;
                                                }
                                                else {
                                                    return '-';
                                                }
                                            }
                                        }]
                                }]
                        }]
                }]
        } : {
            type: FormItemTypes.ContainerItem,
            name: 'header',
            columnSize: 12,
            spacing: 2.5,
            // bgcolor: secondary[50],
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'jobcardInvoiceDetails',
                    label: 'job card invoice details',
                    value: '',
                    containerProps: {
                        display: 'inline-flex',
                        justifyContent: 'space-between',
                        alignItems: 'baseline',
                        gap: 1
                    },
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontWeight: 'medium',
                        fontSize: 'sm'
                    },
                    fontWeight: 'medium',
                    fontSize: 'sm',
                    columnSize: 6
                }, {
                    type: FormItemTypes.Typography,
                    name: 'Invoice summary ',
                    label: 'Invoice summary ',
                    value: '',
                    containerProps: {
                        display: 'inline-flex',
                        justifyContent: 'space-between',
                        alignItems: 'baseline',
                        gap: 1
                    },
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontWeight: 'medium',
                        fontSize: 'sm'
                    },
                    fontWeight: 'medium',
                    fontSize: 'sm',
                    columnSize: 6
                }, {
                    type: FormItemTypes.CardComponent,
                    name: 'header',
                    columnSize: 6,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: 'JC invoice details',
                            label: 'JC invoice details',
                            display: 'flex',
                            justifyContent: 'space-between',
                            columnSize: 12,
                            spacing: 0,
                            padding: '8px 0px 0px 12px ',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'InvoiceNumber',
                                    label: 'Job card invoice number:',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        textOverflow: 'unset',
                                        minWidth: '40%'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'InvoiceDate',
                                    label: 'invoice date:',
                                    value: null,
                                    valueGetter: function (formValues, field) {
                                        var _field$name, _field$name2;
                                        return formValues !== null && formValues !== void 0 && formValues[(_field$name = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name !== void 0 ? _field$name : ''] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name2 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name2 !== void 0 ? _field$name2 : '']).format('DD MMM, YYYY') : '-';
                                    },
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        textOverflow: 'unset',
                                        minWidth: '40%'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'JobCardNo',
                                    label: 'Job card number:',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        textOverflow: 'unset',
                                        minWidth: '40%'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'PostingTypeName',
                                    label: 'Posting type:',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        textOverflow: 'unset',
                                        minWidth: '40%'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        if (formData !== null && formData !== void 0 && formData.PostingTypeName) {
                                            var PostingTypeName = formData !== null && formData !== void 0 && formData.PostingTypeName ? formData === null || formData === void 0 ? void 0 : formData.PostingTypeName : '-';
                                            return PostingTypeName;
                                        }
                                        else {
                                            return '-';
                                        }
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'SeriveType',
                                    label: 'Service type:',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        textOverflow: 'unset',
                                        minWidth: '40%'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        if (formData !== null && formData !== void 0 && formData.SeriveType) {
                                            var SeriveType = formData !== null && formData !== void 0 && formData.SeriveType ? formData === null || formData === void 0 ? void 0 : formData.SeriveType : '-';
                                            return SeriveType;
                                        }
                                        else {
                                            return '-';
                                        }
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'ServiceAdvisorName',
                                    label: 'Service advisor',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        textOverflow: 'unset',
                                        minWidth: '40%'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        if (formData !== null && formData !== void 0 && formData.ServiceAdvisorName) {
                                            var ServiceAdvisorName = formData !== null && formData !== void 0 && formData.ServiceAdvisorName ? formData === null || formData === void 0 ? void 0 : formData.ServiceAdvisorName : '-';
                                            return ServiceAdvisorName;
                                        }
                                        else {
                                            return '-';
                                        }
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'CampaignName',
                                    label: 'Campaign: ',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        textOverflow: 'unset',
                                        minWidth: '40%'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        if (formData !== null && formData !== void 0 && formData.CampaignName) {
                                            var CampaignName = formData !== null && formData !== void 0 && formData.CampaignName ? formData === null || formData === void 0 ? void 0 : formData.CampaignName : '-';
                                            return CampaignName;
                                        }
                                        else {
                                            return '-';
                                        }
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'DelayReason',
                                    label: 'Delay reason:',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        textOverflow: 'unset',
                                        minWidth: '40%'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        if (formData !== null && formData !== void 0 && formData.DelayReason) {
                                            var DelayReason = formData !== null && formData !== void 0 && formData.DelayReason ? formData === null || formData === void 0 ? void 0 : formData.DelayReason : '-';
                                            return DelayReason;
                                        }
                                        else {
                                            return '-';
                                        }
                                    }
                                }]
                        }]
                }, {
                    type: FormItemTypes.CardComponent,
                    name: 'header',
                    columnSize: 6,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            label: 'Invoice summary',
                            display: 'flex',
                            justifyContent: 'space-between',
                            columnSize: 12,
                            spacing: 0,
                            padding: '8px 0px 0px 12px ',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'GrandTotal',
                                    label: 'Basic amount:',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        textOverflow: 'unset',
                                        minWidth: '40%'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        if (formData !== null && formData !== void 0 && formData.GrandTotal) {
                                            var GrandTotal = formData !== null && formData !== void 0 && formData.GrandTotal ? formData === null || formData === void 0 ? void 0 : formData.GrandTotal : '-';
                                            return GrandTotal;
                                        }
                                        else {
                                            return '-';
                                        }
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'TotalDiscount',
                                    label: 'Discount: ',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        textOverflow: 'unset',
                                        minWidth: '40%'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        if (formData !== null && formData !== void 0 && formData.TotalDiscount) {
                                            var TotalDiscount = formData !== null && formData !== void 0 && formData.TotalDiscount ? formData === null || formData === void 0 ? void 0 : formData.TotalDiscount : '-';
                                            return TotalDiscount;
                                        }
                                        else {
                                            return '-';
                                        }
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'OtherCharges',
                                    label: 'Charges: ',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        if (formData !== null && formData !== void 0 && formData.OtherCharges) {
                                            var OtherCharges = formData !== null && formData !== void 0 && formData.OtherCharges ? formData === null || formData === void 0 ? void 0 : formData.OtherCharges : '-';
                                            return OtherCharges;
                                        }
                                        else {
                                            return '-';
                                        }
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'TaxableAmount',
                                    label: 'Taxable amount: ',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        if (formData !== null && formData !== void 0 && formData.TaxableAmount) {
                                            var TaxableAmount = formData !== null && formData !== void 0 && formData.TaxableAmount ? formData === null || formData === void 0 ? void 0 : formData.TaxableAmount : '-';
                                            return TaxableAmount;
                                        }
                                        else {
                                            return '-';
                                        }
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'CGSTAmount',
                                    label: 'CGST',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        if (formData !== null && formData !== void 0 && formData.CGSTAmount) {
                                            var CGSTAmount = formData !== null && formData !== void 0 && formData.CGSTAmount ? formData === null || formData === void 0 ? void 0 : formData.CGSTAmount : '-';
                                            return CGSTAmount;
                                        }
                                        else {
                                            return '-';
                                        }
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'SGSTAmount',
                                    label: 'SGST',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        if (formData !== null && formData !== void 0 && formData.CGSTAmount) {
                                            var CGSTAmount = formData !== null && formData !== void 0 && formData.CGSTAmount ? formData === null || formData === void 0 ? void 0 : formData.CGSTAmount : '-';
                                            return CGSTAmount;
                                        }
                                        else {
                                            return '-';
                                        }
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'IGStAmount',
                                    label: 'IGST: ',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        if (formData !== null && formData !== void 0 && formData.IGStAmount) {
                                            var IGStAmount = formData !== null && formData !== void 0 && formData.IGStAmount ? formData === null || formData === void 0 ? void 0 : formData.IGStAmount : '-';
                                            return IGStAmount;
                                        }
                                        else {
                                            return '-';
                                        }
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'GrandTotal',
                                    label: 'Grand total:',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        if (formData !== null && formData !== void 0 && formData.GrandTotal) {
                                            var GrandTotal = formData !== null && formData !== void 0 && formData.GrandTotal ? formData === null || formData === void 0 ? void 0 : formData.GrandTotal : '-';
                                            return GrandTotal;
                                        }
                                        else {
                                            return '-';
                                        }
                                    }
                                }]
                        }]
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    label: 'Payment detail',
                    value: '',
                    containerProps: {
                        display: 'inline-flex',
                        justifyContent: 'space-between',
                        alignItems: 'baseline',
                        gap: 1
                    },
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontWeight: 'medium',
                        fontSize: 'sm'
                    },
                    fontWeight: 'medium',
                    fontSize: 'sm',
                    columnSize: 6
                }, {
                    type: FormItemTypes.Typography,
                    name: 'Customer details',
                    label: 'Customer details',
                    value: '',
                    containerProps: {
                        display: 'inline-flex',
                        justifyContent: 'space-between',
                        alignItems: 'baseline',
                        gap: 1
                    },
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontWeight: 'medium',
                        fontSize: 'sm'
                    },
                    fontWeight: 'medium',
                    fontSize: 'sm',
                    columnSize: 6
                }, {
                    type: FormItemTypes.CardComponent,
                    name: 'header',
                    columnSize: 6,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: 'JC invoice return details',
                            label: 'JC invoice return details',
                            display: 'flex',
                            justifyContent: 'space-between',
                            columnSize: 12,
                            spacing: 0,
                            padding: '8px 0px 0px 12px ',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'PaidAmount',
                                    label: 'Paid amount:',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'OutStandingAmount',
                                    label: 'Outstanding amount:',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'PaymentMode',
                                    label: 'Payment mode:',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        if ((formData === null || formData === void 0 ? void 0 : formData.PaymentMode) === 1)
                                            return 'Cash';
                                        if ((formData === null || formData === void 0 ? void 0 : formData.PaymentMode) === 2)
                                            return 'Credit';
                                        return '-';
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'PaymentTypeName',
                                    label: 'Payment method:',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        if (formData !== null && formData !== void 0 && formData.PaymentTypeName) {
                                            var PaymentTypeName = formData !== null && formData !== void 0 && formData.PaymentTypeName ? formData === null || formData === void 0 ? void 0 : formData.PaymentTypeName : '-';
                                            return PaymentTypeName;
                                        }
                                        else {
                                            return '-';
                                        }
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'InvoiceDate',
                                    label: 'Payment date:',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        if (formData !== null && formData !== void 0 && formData.InvoiceDate) {
                                            var InvoiceDate = formData !== null && formData !== void 0 && formData.InvoiceDate ? dayjs.utc(formData === null || formData === void 0 ? void 0 : formData.InvoiceDate).format('DD MMM, YYYY') : '-';
                                            return InvoiceDate;
                                        }
                                        else {
                                            return '-';
                                        }
                                    }
                                }]
                        }]
                }, {
                    type: FormItemTypes.CardComponent,
                    name: 'header',
                    columnSize: 6,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: 'Customer details',
                            label: 'Customer details',
                            display: 'flex',
                            justifyContent: 'space-between',
                            columnSize: 12,
                            spacing: 0,
                            padding: '8px 0px 0px 12px ',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'Name',
                                    label: 'Name:',
                                    value: (_ref3 = (_customerInfo$data$Pe2 = customerInfo === null || customerInfo === void 0 || (_customerInfo$data7 = customerInfo.data) === null || _customerInfo$data7 === void 0 || (_customerInfo$data7 = _customerInfo$data7.Person) === null || _customerInfo$data7 === void 0 ? void 0 : _customerInfo$data7.GivenName) !== null && _customerInfo$data$Pe2 !== void 0 ? _customerInfo$data$Pe2 : '-' + '' + (customerInfo === null || customerInfo === void 0 || (_customerInfo$data8 = customerInfo.data) === null || _customerInfo$data8 === void 0 || (_customerInfo$data8 = _customerInfo$data8.Person) === null || _customerInfo$data8 === void 0 ? void 0 : _customerInfo$data8.FamilyName)) !== null && _ref3 !== void 0 ? _ref3 : '-',
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'Mobile no:',
                                    label: 'Mobile no.:',
                                    value: customerInfo === null || customerInfo === void 0 || (_customerInfo$data9 = customerInfo.data) === null || _customerInfo$data9 === void 0 ? void 0 : _customerInfo$data9.MobileNumber,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'Address :',
                                    label: 'Address:',
                                    value: customerInfo === null || customerInfo === void 0 || (_customerInfo$data10 = customerInfo.data) === null || _customerInfo$data10 === void 0 || (_customerInfo$data10 = _customerInfo$data10.Address[0]) === null || _customerInfo$data10 === void 0 ? void 0 : _customerInfo$data10.Address1,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        textOverflow: 'unset',
                                        minWidth: '40%'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'Mail',
                                    label: 'Mail:',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        var _customerInfo$data11;
                                        var email = customerInfo === null || customerInfo === void 0 || (_customerInfo$data11 = customerInfo.data) === null || _customerInfo$data11 === void 0 ? void 0 : _customerInfo$data11.Email;
                                        return email ? email : '-';
                                    }
                                }]
                        }]
                }, {
                    type: FormItemTypes.Typography,
                    name: 'Vehicle details',
                    label: 'Vehicle details',
                    value: '',
                    containerProps: {
                        display: 'inline-flex',
                        justifyContent: 'space-between',
                        alignItems: 'baseline',
                        gap: 1
                    },
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontWeight: 'medium',
                        fontSize: 'sm'
                    },
                    fontWeight: 'medium',
                    fontSize: 'sm',
                    columnSize: 6
                }, {
                    type: FormItemTypes.Typography,
                    name: 'Insurance details',
                    label: 'Insurance details',
                    value: '',
                    containerProps: {
                        display: 'inline-flex',
                        justifyContent: 'space-between',
                        alignItems: 'baseline',
                        gap: 1
                    },
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontWeight: 'medium',
                        fontSize: 'sm'
                    },
                    fontWeight: 'medium',
                    fontSize: 'sm',
                    columnSize: 6
                }, {
                    type: FormItemTypes.CardComponent,
                    name: 'header',
                    columnSize: 6,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: 'Vehicle details',
                            label: 'Vehicle details',
                            display: 'flex',
                            justifyContent: 'space-between',
                            columnSize: 12,
                            spacing: 0,
                            padding: '8px 0px 0px 12px ',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'RegistrationNo',
                                    label: 'Registration no.:',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        var RegistrationNo = formData === null || formData === void 0 ? void 0 : formData.RegistrationNo;
                                        return RegistrationNo !== null && RegistrationNo !== undefined ? RegistrationNo : '-';
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'ProductName',
                                    label: 'Model',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        var ProductName = formData === null || formData === void 0 ? void 0 : formData.ProductName;
                                        return ProductName !== null && ProductName !== undefined ? ProductName : '-';
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'EngineNo',
                                    label: 'Engine no.:',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        var EngineNo = formData === null || formData === void 0 ? void 0 : formData.EngineNo;
                                        return EngineNo !== null && EngineNo !== undefined ? EngineNo : '-';
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'VinNo',
                                    label: 'Chassis no.:',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        var VinNo = formData === null || formData === void 0 ? void 0 : formData.VinNo;
                                        return VinNo !== null && VinNo !== undefined ? VinNo : '-';
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    label: 'Date of sale:',
                                    value: (_crud$JobCardInvoices9 = crud[JobCardInvoicesKeys === null || JobCardInvoicesKeys === void 0 ? void 0 : JobCardInvoicesKeys.ViewInvoiceDetails]) !== null && _crud$JobCardInvoices9 !== void 0 && (_crud$JobCardInvoices9 = _crud$JobCardInvoices9.data) !== null && _crud$JobCardInvoices9 !== void 0 && _crud$JobCardInvoices9.PaymentDuedate ? dayjs((_crud$JobCardInvoices10 = (_crud$JobCardInvoices11 = crud[JobCardInvoicesKeys === null || JobCardInvoicesKeys === void 0 ? void 0 : JobCardInvoicesKeys.ViewInvoiceDetails]) === null || _crud$JobCardInvoices11 === void 0 || (_crud$JobCardInvoices11 = _crud$JobCardInvoices11.data) === null || _crud$JobCardInvoices11 === void 0 ? void 0 : _crud$JobCardInvoices11.PaymentDuedate) !== null && _crud$JobCardInvoices10 !== void 0 ? _crud$JobCardInvoices10 : '-').format('DD MM YYYY') : '-',
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }]
                        }]
                }, {
                    type: FormItemTypes.CardComponent,
                    name: 'header',
                    columnSize: 6,
                    containerProps: {
                        spacing: 0
                    },
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: 'Insurance details',
                            label: 'Insurance details',
                            display: 'flex',
                            justifyContent: 'space-between',
                            columnSize: 12,
                            spacing: 0,
                            padding: '8px 0px 0px 12px ',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'InsuredName',
                                    label: 'Insurer name:',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        textOverflow: 'unset',
                                        minWidth: '40%'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        if (formData !== null && formData !== void 0 && formData.InsuredName) {
                                            var InsuredName = formData !== null && formData !== void 0 && formData.InsuredName ? formData === null || formData === void 0 ? void 0 : formData.InsuredName : '-';
                                            return InsuredName;
                                        }
                                        else {
                                            return '-';
                                        }
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'PolicyExpiryDate',
                                    label: 'Policy date:',
                                    value: (_crud$JobCardInvoices12 = crud[JobCardInvoicesKeys === null || JobCardInvoicesKeys === void 0 ? void 0 : JobCardInvoicesKeys.ViewInvoiceDetails]) !== null && _crud$JobCardInvoices12 !== void 0 && (_crud$JobCardInvoices12 = _crud$JobCardInvoices12.data) !== null && _crud$JobCardInvoices12 !== void 0 && _crud$JobCardInvoices12.PolicyExpiryDate ? dayjs((_crud$JobCardInvoices13 = crud[JobCardInvoicesKeys === null || JobCardInvoicesKeys === void 0 ? void 0 : JobCardInvoicesKeys.ViewInvoiceDetails]) === null || _crud$JobCardInvoices13 === void 0 || (_crud$JobCardInvoices13 = _crud$JobCardInvoices13.data) === null || _crud$JobCardInvoices13 === void 0 ? void 0 : _crud$JobCardInvoices13.PolicyExpiryDate).format('DD MM YYYY') : '-',
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'CoverageTypeName',
                                    label: 'Policy type:',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        if (formData !== null && formData !== void 0 && formData.CoverageTypeName) {
                                            var CoverageTypeName = formData !== null && formData !== void 0 && formData.CoverageTypeName ? formData === null || formData === void 0 ? void 0 : formData.CoverageTypeName : '-';
                                            return CoverageTypeName;
                                        }
                                        else {
                                            return '-';
                                        }
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'PolicyNumber',
                                    label: 'Policy no.:',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        if (formData !== null && formData !== void 0 && formData.PolicyNumber) {
                                            var PolicyNumber = formData !== null && formData !== void 0 && formData.PolicyNumber ? formData === null || formData === void 0 ? void 0 : formData.PolicyNumber : '-';
                                            return PolicyNumber;
                                        }
                                        else {
                                            return '-';
                                        }
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'InsuranceClaimNumber:',
                                    label: 'Insurance claim number:',
                                    value: null,
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        if (formData !== null && formData !== void 0 && formData.InsuranceClaimNumberd) {
                                            var InsuranceClaimNumberd = formData !== null && formData !== void 0 && formData.InsuranceClaimNumberd ? formData === null || formData === void 0 ? void 0 : formData.InsuranceClaimNumberd : '-';
                                            return InsuranceClaimNumberd;
                                        }
                                        else {
                                            return '-';
                                        }
                                    }
                                }]
                        }]
                }]
        }, isMobile ? {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    // name: '',
                    // columnSize: 12,
                    // spacing: 0,
                    // width: 'auto',
                    // bgcolor:'red',
                    // sx: {
                    //     overflowX: 'auto',
                    //     overflowY: 'visible',
                    //     flexWrap: 'nowrap',
                    //     width: '100%',
                    //     scrollbarWidth: 'none'
                    // },
                    // position: 'static',
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    border: '1px solid ',
                    borderColor: 'secondary.200',
                    padding: '12px',
                    gap: '20px',
                    borderRadius: '12px',
                    sx: {
                        overflowX: 'auto',
                        overflowY: 'visible',
                        flexWrap: 'nowrap',
                        width: '100%',
                        scrollbarWidth: 'none'
                    },
                    elements: [{
                            type: FormItemTypes.Button,
                            label: '',
                            name: JCIPostingTypes.Paid,
                            columnSize: 0,
                            variant: 'text',
                            color: 'secondary',
                            size: 'small',
                            setFormState: function (state, val, field) { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    return [2 /*return*/, {
                                            SelectedButton: field.name
                                        }];
                                });
                            }); },
                            setFieldProps: function (state, value) {
                                var _state$PaidAmount;
                                return {
                                    type: FormItemTypes.Button,
                                    variant: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'outlined' : 'text',
                                    color: 'secondary',
                                    sx: {
                                        fontWeight: 'strong',
                                        color: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'text.primary' : undefined,
                                        bgcolor: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'white' : "secondary.100"
                                    },
                                    children: ['Paid', /*#__PURE__*/ React.createElement(Chip, {
                                            variant: "filled",
                                            size: "small",
                                            color: "secondary",
                                            sx: {
                                                fontWeight: 'medium',
                                                color: 'text.primary'
                                            },
                                            label: (_state$PaidAmount = state === null || state === void 0 ? void 0 : state.PaidAmount) !== null && _state$PaidAmount !== void 0 ? _state$PaidAmount : 0
                                        })]
                                };
                            }
                        }, {
                            type: FormItemTypes.Button,
                            label: '',
                            name: JCIPostingTypes.Expenses,
                            columnSize: 0,
                            variant: 'text',
                            color: 'secondary',
                            size: 'small',
                            fullWidth: true,
                            setFormState: function (state, val, field) { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    return [2 /*return*/, {
                                            SelectedButton: field.name
                                        }];
                                });
                            }); },
                            setFieldProps: function (state, value) {
                                var _state$ExpenseAmount;
                                return {
                                    type: FormItemTypes.Button,
                                    variant: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'outlined' : 'text',
                                    color: 'secondary',
                                    sx: {
                                        fontWeight: 'strong',
                                        color: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'text.primary' : undefined,
                                        bgcolor: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'white' : "secondary.100"
                                    },
                                    children: ['Expense', /*#__PURE__*/ React.createElement(Chip, {
                                            variant: "filled",
                                            size: "small",
                                            color: "secondary",
                                            sx: {
                                                fontWeight: 'medium',
                                                color: 'text.primary'
                                            },
                                            label: (_state$ExpenseAmount = state === null || state === void 0 ? void 0 : state.ExpenseAmount) !== null && _state$ExpenseAmount !== void 0 ? _state$ExpenseAmount : 0
                                        })]
                                };
                            }
                        }, {
                            type: FormItemTypes.Button,
                            label: '',
                            name: JCIPostingTypes.Claims,
                            columnSize: 0,
                            variant: 'text',
                            color: 'secondary',
                            size: 'small',
                            fullWidth: true,
                            setFormState: function (state, val, field) { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    return [2 /*return*/, {
                                            SelectedButton: field.name
                                        }];
                                });
                            }); },
                            setFieldProps: function (state, value) {
                                var _state$ClaimAmount;
                                return {
                                    type: FormItemTypes.Button,
                                    variant: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'outlined' : 'text',
                                    color: 'secondary',
                                    sx: {
                                        fontWeight: 'strong',
                                        color: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'text.primary' : undefined,
                                        bgcolor: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'white' : "secondary.100"
                                    },
                                    children: ['Claims', /*#__PURE__*/ React.createElement(Chip, {
                                            variant: "filled",
                                            size: "small",
                                            color: "secondary",
                                            sx: {
                                                fontWeight: 'medium',
                                                color: 'text.primary'
                                            },
                                            label: (_state$ClaimAmount = state === null || state === void 0 ? void 0 : state.ClaimAmount) !== null && _state$ClaimAmount !== void 0 ? _state$ClaimAmount : 0
                                        })]
                                };
                            }
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'part',
                    label: '',
                    value: null,
                    sx: {
                        bgcolor: 'transparent',
                        border: 'none'
                    },
                    detailPanelProps: {
                        spacing: 0
                    },
                    summaryProps: {
                        sx: {
                            padding: 0
                        }
                    },
                    summary: [{
                            type: FormItemTypes.Typography,
                            name: 'partDetail',
                            label: '',
                            value: null,
                            children: 'Parts',
                            columnSize: 0,
                            fontWeight: 'strong',
                            fontSize: 'lg'
                        }, {
                            type: FormItemTypes.Chip,
                            name: 'Count',
                            columnSize: 0,
                            size: 'small',
                            variant: 'outlined',
                            color: 'info',
                            sx: {
                                ml: '8px'
                            },
                            valueGetter: function (formValues, field) {
                                var _formValues$Parts;
                                return (formValues === null || formValues === void 0 || (_formValues$Parts = formValues.Parts) === null || _formValues$Parts === void 0 ? void 0 : _formValues$Parts.length) || 0;
                            },
                            setFieldProps: function (formValues, currValue) {
                                var _formValues$Parts$len, _formValues$Parts2;
                                return {
                                    type: FormItemTypes.Chip,
                                    sx: {
                                        display: ((_formValues$Parts$len = formValues === null || formValues === void 0 || (_formValues$Parts2 = formValues.Parts) === null || _formValues$Parts2 === void 0 ? void 0 : _formValues$Parts2.length) !== null && _formValues$Parts$len !== void 0 ? _formValues$Parts$len : 0) > 0 ? 'inline-flex' : 'none',
                                        ml: '4px'
                                    }
                                };
                            }
                        }],
                    elements: [{
                            type: FormItemTypes.List,
                            name: 'Parts',
                            columnSize: 12,
                            value: null,
                            disableCheckboxSelection: true,
                            columns: [{
                                    field: 'Part',
                                    flex: 1,
                                    renderCell: function (params) {
                                        var _params$row, _params$row2, _params$row3;
                                        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                            variant: "h3"
                                        }, params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.ChildName), /*#__PURE__*/ React.createElement(Typography, {
                                            variant: "h6",
                                            color: "secondary"
                                        }, params !== null && params !== void 0 && (_params$row2 = params.row) !== null && _params$row2 !== void 0 && _params$row2.ChildCode ? '#' + (params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.ChildCode) : ''));
                                    }
                                }],
                            elements: partElements
                        }],
                    columnSize: 12
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'labour',
                    label: '',
                    value: null,
                    sx: {
                        bgcolor: 'transparent',
                        borderLeft: 'none',
                        borderRight: 'none'
                    },
                    summaryProps: {
                        sx: {
                            padding: 0,
                            justifyContent: 'center',
                            alignItems: 'center',
                            display: 'flex'
                        }
                    },
                    detailPanelProps: {
                        spacing: 0
                    },
                    summary: [{
                            type: FormItemTypes.Typography,
                            name: 'labourDetail',
                            label: '',
                            value: null,
                            children: 'Labour',
                            columnSize: 0,
                            fontWeight: 'strong',
                            fontSize: 'lg'
                        }, {
                            type: FormItemTypes.Chip,
                            name: 'Count',
                            columnSize: 0,
                            size: 'small',
                            variant: 'outlined',
                            color: 'info',
                            sx: {
                                ml: '8px'
                            },
                            valueGetter: function (formValues, field) {
                                var _formValues$Labours;
                                return (formValues === null || formValues === void 0 || (_formValues$Labours = formValues.Labours) === null || _formValues$Labours === void 0 ? void 0 : _formValues$Labours.length) || 0;
                            },
                            setFieldProps: function (formValues, currValue) {
                                var _formValues$Labours$l, _formValues$Labours2;
                                return {
                                    type: FormItemTypes.Chip,
                                    sx: {
                                        display: ((_formValues$Labours$l = formValues === null || formValues === void 0 || (_formValues$Labours2 = formValues.Labours) === null || _formValues$Labours2 === void 0 ? void 0 : _formValues$Labours2.length) !== null && _formValues$Labours$l !== void 0 ? _formValues$Labours$l : 0) > 0 ? 'inline-flex' : 'none',
                                        ml: '4px'
                                    }
                                };
                            }
                        }],
                    elements: [{
                            type: FormItemTypes.List,
                            name: 'Labours',
                            columnSize: 12,
                            value: null,
                            disableCheckboxSelection: true,
                            columns: [{
                                    field: 'Labour',
                                    flex: 1,
                                    renderCell: function (params) {
                                        var _params$row4, _params$row5, _params$row6;
                                        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                            variant: "h3"
                                        }, params === null || params === void 0 || (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.ChildName), /*#__PURE__*/ React.createElement(Typography, {
                                            variant: "h6",
                                            color: "secondary"
                                        }, params !== null && params !== void 0 && (_params$row5 = params.row) !== null && _params$row5 !== void 0 && _params$row5.ChildCode ? '#' + (params === null || params === void 0 || (_params$row6 = params.row) === null || _params$row6 === void 0 ? void 0 : _params$row6.ChildCode) : ''));
                                    }
                                }],
                            elements: labourElements
                        }],
                    columnSize: 12
                }]
        } : {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            border: '1px solid ',
            borderColor: 'secondary.200',
            padding: '12px',
            gap: '20px',
            borderRadius: '12px',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    width: 'auto',
                    sx: {
                        overflowX: 'auto',
                        overflowY: 'visible',
                        flexWrap: 'nowrap',
                        width: '100%',
                        scrollbarWidth: 'none'
                    },
                    position: 'static',
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: '',
                            columnSize: 0,
                            contentProps: {
                                spacing: 0,
                                gap: '16px'
                            },
                            sx: {
                                padding: {
                                    xs: '6px',
                                    md: "6px"
                                },
                                rowGap: '16px',
                                bgcolor: 'secondary.100',
                                borderColor: 'secondary.200'
                            },
                            elements: [{
                                    type: FormItemTypes.Button,
                                    label: '',
                                    name: JCIPostingTypes.Paid,
                                    columnSize: 0,
                                    variant: 'text',
                                    color: 'secondary',
                                    size: 'small',
                                    setFormState: function (state, val, field) { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            return [2 /*return*/, {
                                                    SelectedButton: field.name
                                                }];
                                        });
                                    }); },
                                    setFieldProps: function (state, value) {
                                        var _state$PaidAmount2;
                                        return {
                                            type: FormItemTypes.Button,
                                            variant: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'outlined' : 'text',
                                            color: 'secondary',
                                            sx: {
                                                fontWeight: 'strong',
                                                color: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'text.primary' : undefined,
                                                bgcolor: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'white' : "secondary.100"
                                            },
                                            children: ['Paid', /*#__PURE__*/ React.createElement(Chip, {
                                                    variant: "filled",
                                                    size: "small",
                                                    color: "secondary",
                                                    sx: {
                                                        fontWeight: 'medium',
                                                        color: 'text.primary'
                                                    },
                                                    label: (_state$PaidAmount2 = state === null || state === void 0 ? void 0 : state.PaidAmount) !== null && _state$PaidAmount2 !== void 0 ? _state$PaidAmount2 : 0
                                                })]
                                        };
                                    }
                                }, {
                                    type: FormItemTypes.Button,
                                    label: '',
                                    name: JCIPostingTypes.Expenses,
                                    columnSize: 0,
                                    variant: 'text',
                                    color: 'secondary',
                                    size: 'small',
                                    fullWidth: true,
                                    setFormState: function (state, val, field) { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            return [2 /*return*/, {
                                                    SelectedButton: field.name
                                                }];
                                        });
                                    }); },
                                    setFieldProps: function (state, value) {
                                        var _state$ExpenseAmount2;
                                        return {
                                            type: FormItemTypes.Button,
                                            variant: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'outlined' : 'text',
                                            color: 'secondary',
                                            sx: {
                                                fontWeight: 'strong',
                                                color: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'text.primary' : undefined,
                                                bgcolor: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'white' : "secondary.100"
                                            },
                                            children: ['Expense', /*#__PURE__*/ React.createElement(Chip, {
                                                    variant: "filled",
                                                    size: "small",
                                                    color: "secondary",
                                                    sx: {
                                                        fontWeight: 'medium',
                                                        color: 'text.primary'
                                                    },
                                                    label: (_state$ExpenseAmount2 = state === null || state === void 0 ? void 0 : state.ExpenseAmount) !== null && _state$ExpenseAmount2 !== void 0 ? _state$ExpenseAmount2 : 0
                                                })]
                                        };
                                    }
                                }, {
                                    type: FormItemTypes.Button,
                                    label: '',
                                    name: JCIPostingTypes.Claims,
                                    columnSize: 0,
                                    variant: 'text',
                                    color: 'secondary',
                                    size: 'small',
                                    fullWidth: true,
                                    setFormState: function (state, val, field) { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            return [2 /*return*/, {
                                                    SelectedButton: field.name
                                                }];
                                        });
                                    }); },
                                    setFieldProps: function (state, value) {
                                        var _state$ClaimAmount2;
                                        return {
                                            type: FormItemTypes.Button,
                                            variant: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'outlined' : 'text',
                                            color: 'secondary',
                                            sx: {
                                                fontWeight: 'strong',
                                                color: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'text.primary' : undefined,
                                                bgcolor: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'white' : "secondary.100"
                                            },
                                            children: ['Claims', /*#__PURE__*/ React.createElement(Chip, {
                                                    variant: "filled",
                                                    size: "small",
                                                    color: "secondary",
                                                    sx: {
                                                        fontWeight: 'medium',
                                                        color: 'text.primary'
                                                    },
                                                    label: (_state$ClaimAmount2 = state === null || state === void 0 ? void 0 : state.ClaimAmount) !== null && _state$ClaimAmount2 !== void 0 ? _state$ClaimAmount2 : 0
                                                })]
                                        };
                                    }
                                }]
                        }]
                }, {
                    type: FormItemTypes.Custom,
                    name: 'Parts',
                    element: PartInvoiceDetails,
                    columnSize: 12
                }, {
                    type: FormItemTypes.Custom,
                    name: 'Labours',
                    element: LabourInvoiceDetails,
                    columnSize: 12
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            sx: {
                overflowX: {
                    xs: 'auto',
                    md: 'visible'
                },
                display: 'flex',
                flexDirection: {
                    xs: 'row',
                    md: 'row'
                },
                gap: 2,
                paddingBottom: {
                    xs: 2,
                    md: 4
                },
                bgcolor: 'secondary.50',
                padding: isMobile ? 0 : 3
            },
            setFieldProps: function (formValues, currValue, field, formApi) {
                var _formValues$RelatedIn;
                return {
                    hidden: !((formValues === null || formValues === void 0 || (_formValues$RelatedIn = formValues.RelatedInvoices) === null || _formValues$RelatedIn === void 0 ? void 0 : _formValues$RelatedIn.length) > 0)
                };
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    display: 'flex',
                    justifyContent: 'space-between',
                    sx: {
                        marginBottom: 1.5
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: true,
                            children: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                component: "span",
                                fontWeight: "medium"
                            }, "Other invoices - "), /*#__PURE__*/ React.createElement(Typography, {
                                component: "span",
                                sx: {
                                    fontSize: 'lg',
                                    fontWeight: 'strong'
                                }
                            }, (_crud$JobCardInvoices14 = crud[JobCardInvoicesKeys === null || JobCardInvoicesKeys === void 0 ? void 0 : JobCardInvoicesKeys.ViewInvoiceDetails]) === null || _crud$JobCardInvoices14 === void 0 || (_crud$JobCardInvoices14 = _crud$JobCardInvoices14.data) === null || _crud$JobCardInvoices14 === void 0 ? void 0 : _crud$JobCardInvoices14.JobCardNo))
                        }, {
                            type: FormItemTypes.Chip,
                            name: 'Status',
                            variant: 'outlined',
                            size: 'small',
                            columnSize: 0,
                            color: 'info',
                            sx: {
                                borderRadius: '20px',
                                display: 'flex'
                            },
                            value: (_crud$JobCardInvoices15 = crud[JobCardInvoicesKeys === null || JobCardInvoicesKeys === void 0 ? void 0 : JobCardInvoicesKeys.ViewInvoiceDetails]) === null || _crud$JobCardInvoices15 === void 0 || (_crud$JobCardInvoices15 = _crud$JobCardInvoices15.data) === null || _crud$JobCardInvoices15 === void 0 ? void 0 : _crud$JobCardInvoices15.RelatedInvoices.length
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    sx: {
                        overflow: 'scroll'
                    },
                    elements: [{
                            type: FormItemTypes.Box,
                            name: '',
                            columnSize: 0,
                            display: 'flex',
                            bgcolor: 'white',
                            padding: '8px',
                            gap: '20px',
                            alignItems: 'center',
                            borderRadius: '8px',
                            setFieldProps: function (state) { return ({
                                type: FormItemTypes.Box,
                                name: '',
                                elements: multiInvoiceList === null || multiInvoiceList === void 0 ? void 0 : multiInvoiceList.map(function (item, index) { return ({
                                    type: FormItemTypes.Button,
                                    name: "MultiInvoiceButton_".concat(index),
                                    label: "",
                                    variant: 'outlined',
                                    columnSize: 12,
                                    sx: {
                                        border: '1px solid',
                                        borderColor: 'primary.200',
                                        borderRadius: '8px',
                                        backgroundColor: 'white',
                                        textAlign: 'center'
                                    },
                                    children: /*#__PURE__*/ React.createElement(Box, {
                                        width: "157px",
                                        height: "60px"
                                    }, /*#__PURE__*/ React.createElement(Typography, {
                                        sx: {
                                            color: 'primary.500',
                                            fontSize: 'base',
                                            fontWeight: 'medium'
                                        }
                                    }, item === null || item === void 0 ? void 0 : item.InvoiceNumber), /*#__PURE__*/ React.createElement(Typography, {
                                        sx: {
                                            color: 'secondary.500',
                                            fontSize: 'base',
                                            fontWeight: 'normal'
                                        }
                                    }, item === null || item === void 0 ? void 0 : item.InvoiceType)),
                                    setFormState: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        var invoiceDetails;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, getViewInvoiceDetails({
                                                        request: {
                                                            id: item === null || item === void 0 ? void 0 : item.InvoiceId,
                                                            CustomerId: data === null || data === void 0 ? void 0 : data.CustomerId
                                                        }
                                                    })];
                                                case 1:
                                                    invoiceDetails = _a.sent();
                                                    return [2 /*return*/, invoiceDetails === null || invoiceDetails === void 0 ? void 0 : invoiceDetails.data];
                                            }
                                        });
                                    }); }
                                }); })
                            }); }
                        }]
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
        p: 2,
        sx: {
            paddingTop: {
                md: '60px',
                lg: '60px'
            }
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        gridProps: {
            spacing: 0,
            gap: '20px'
        },
        formData: invoiceDetails,
        getFormAPI: getViewInvoiceDetails,
        getKey: JobCardInvoicesKeys.ViewInvoiceDetails,
        getRequest: {
            id: data === null || data === void 0 ? void 0 : data.id,
            CustomerId: data === null || data === void 0 ? void 0 : data.CustomerId
        }
    })));
};
export default InvoiceDetails;
